<div class="password-criteria" aria-live="polite">
  <span class="criteria-title">{{ 'Your password must have:' | translate }}</span>
  <ul class="criteria-list">
    @for (rule of rules; track $index) {
      <li class="criteria-item" [class.met]="rule.met">
        <mat-icon class="criteria-icon">{{ rule.met ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
        <span>{{ rule.label | translate: rule.params }}</span>
      </li>
    }
  </ul>
</div>
